import { faQuestionCircle, faTicket } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Impact } from '@sorare/core/src/atoms/animations/Impact';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelM, LabelS } from '@sorare/core/src/atoms/typography';
import { wheel } from '@sorare/core/src/lib/glossary';

import { HowToWinTicketDialog } from '../HowToWinTicketDialog';

const Root = styled(Vertical).attrs({ center: true })`
  grid-area: tickets;
  width: 100%;
`;

export const Tickets = ({ nb = 0 }: { nb: number }) => {
  const [open, setOpen] = useState(false);
  return (
    <Root center>
      <LabelM color="var(--c-nd-600)">
        <FormattedMessage
          id="marketplace.wheel.tickets.title"
          defaultMessage="Tickets"
        />
      </LabelM>
      <Impact trigger={nb}>
        <HeadlineL>
          <Horizontal>
            <FontAwesomeIcon icon={faTicket} />
            <FormattedNumber value={nb} />
          </Horizontal>
        </HeadlineL>
      </Impact>
      <Button color="transparent" size="compact" onClick={() => setOpen(true)}>
        <LabelS color="var(--c-nd-500)">
          <Horizontal>
            <FontAwesomeIcon icon={faQuestionCircle} />
            <FormattedMessage {...wheel.howToWin} />
          </Horizontal>
        </LabelS>
      </Button>
      <HowToWinTicketDialog open={open} onClose={() => setOpen(false)} />
    </Root>
  );
};
